"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShare = useShare;
const vue_demi_1 = require("vue-demi");
const poster_1 = require("../poster");
const api_1 = require("./api");
const { useUser } = require('@fegobull/webapi').use;
const { uid, isLogin } = useUser();
/**
 * 创建邀请链接二维码
 *
 * @param {string} url 邀请链接
 * @return {*}  {Promise<string>} 返回二维码的Data URL
 */
async function getQrcode(url) {
    const Qr = await Promise.resolve().then(() => __importStar(require("qrcode")));
    const data = await Qr.toDataURL(url, {
        margin: 0,
        scale: 16,
        color: {
            light: '#0000',
            dark: '#000'
        }
    });
    return data;
}
/**
 * 使用分享
 * @param shareConfig 分享配置
 * @returns {
 *  state: {
 *    shareUrl: string;
 *    userInfo: Awaited<ReturnType<typeof getUserInfo>>;
 *  }
 * }
 */
function useShare(shareConfig, poster) {
    const state = (0, vue_demi_1.reactive)({
        shareUrl: '',
        userInfo: null,
        qrCode: '',
        poster: ''
    });
    (0, vue_demi_1.onMounted)(async () => {
        if (!isLogin) {
            return;
        }
        const [shareUrl, userInfo] = await Promise.all([(0, api_1.getShareData)(shareConfig), (0, api_1.getUserInfo)()]);
        if (shareUrl) {
            state.qrCode = await getQrcode(shareUrl);
        }
        state.shareUrl = shareUrl;
        state.userInfo = userInfo;
        if (shareUrl
            &&
                state.qrCode
            && userInfo
            && userInfo.nickname
            && userInfo.avatar
            && poster) {
            state.poster = await (0, poster_1.createPoster)({
                qrCode: state.qrCode,
                nick: userInfo.nickname,
                avatar: userInfo.avatar,
                poster,
                uid: userInfo.uid
            });
        }
    });
    return {
        state
    };
}
//# sourceMappingURL=data:application/json;base64,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